<div class="question-container" *ngIf="!!selection">
    <div class="card-deck" style="width: 100%">

        <div class="card question-report">
            <div (click)="showQuestionReport()" class="card-block card-text text-success selectableTitle" role="tablist" aria-multiselectable="true">Question Report</div>
        </div>

        <div *ngFor="let question of selection.questionEntries; let idx = index" role="tablist" aria-multiselectable="true">
            <div class="card question-detail-container">
                <question-editor-detail [idx]="idx"
                                        [_activated]="getQuestionActive(idx.toString())"
                                        (saveRequest)="saveQuestion($event, idx)"
                                        (deleteRequest)="deleteQuestion($event)"
                                        (setActiveRequest)="setQuestionActive($event)"
                                        [question]="question"
                                        [selection]="selection">
                </question-editor-detail>
            </div>
        </div>
        <div class="card question-detail-container">
         <div class="card-block card-text text-success" role="tablist" aria-multiselectable="true">New Question: </div>
         <question-editor-detail
                                 [idx]="newQuestionText"
                                 [_activated]="getQuestionActive(newQuestionText)"
                                 (saveRequest)="addQuestion($event)"
                                 (deleteRequest)="cancelNewQuestion($event)"
                                 (setActiveRequest)="setQuestionActive($event)"
                                 [selection]="selection"
                                 [question]="newQuestion">
         </question-editor-detail>

        <!--<div class="card-footer">
            <div class="btn-group">
                <button class="btn btn-success" (click)="addNewQuestion()">Add</button>
            </div>
        </div>-->
        </div>
    </div>


</div>
